import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CuratedClientsTable } from './candidateCuratedClientsTable';
import { ClientService } from '../../../../services/clientService';
import { Row, Col, Form } from 'react-bootstrap';
import SigniteButton from '../../../ui-elements/signite-button/signiteButton';

const CandidateCuratedClients = () => {
    const candidateId = useSelector(state => state.personalDetails?.candidateId);

    const [searchClientId, setSearchClientId] = useState(() => {
        return sessionStorage.getItem('curatedClientsSearch') || '';
    });
    const [clientIdSearch, setClientIdSearch] = useState(() => {
        return sessionStorage.getItem('curatedClientsSearchInput') || '';
    });

    const fetchCuratedClients = async ({ candidateId, pageIndex, pageSize }) => {
        const response = await ClientService.getCuratedByClientAndCandidate(
            searchClientId || null,
            candidateId,
            pageIndex,
            pageSize
        );
        return response;
    };

    if (!candidateId) return <p>Loading candidate info...</p>;

    const handleSearch = () => {
        const trimmed = clientIdSearch.trim();
        setSearchClientId(trimmed);

        sessionStorage.setItem('curatedClientsSearch', trimmed);
        sessionStorage.setItem('curatedClientsSearchInput', clientIdSearch);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch();
        }
    };

    return (
        <div>
            <Row className="mb-3">
                <Col xs={12} md={4}>
                    <Form.Control
                        type="text"
                        placeholder="Search by Client ID"
                        value={clientIdSearch}
                        onChange={e => {
                            const value = e.target.value;
                            setClientIdSearch(value);
                            if (value.trim() === "") {
                                setSearchClientId("");
                                sessionStorage.removeItem('curatedClientsSearch');
                            }
                        }}
                        onKeyDown={handleKeyDown}
                    />
                </Col>
                <Col xs="auto">
                    <SigniteButton variant="primary" onClick={handleSearch}>
                        Search
                    </SigniteButton>
                </Col>
            </Row>

            <CuratedClientsTable
                fetchData={fetchCuratedClients}
                candidateId={candidateId}
                searchClientId={searchClientId}
                tableKey={`curatedClients-${searchClientId}`}
            />
        </div>
    );
};

export default CandidateCuratedClients;